const ProductReportChildTableRow = ({row}: any) => {
  return (
    <tr>
      <td></td>
      <td>{row.childSku}</td>
      <td>{row.productName}</td>
      <td>{row.cost}</td>
      <td>{row.purchaserName}</td>
    </tr>
  )
}

export default ProductReportChildTableRow
